  document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);
    
    document.querySelectorAll('.gc-services__header, .gc-services__item').forEach(el => {
      observer.observe(el);
    });
    
    // Staggered animation
    document.querySelectorAll('.gc-services__item').forEach((item, index) => {
      item.style.transitionDelay = `${index * 0.15}s`;
    });
  });